module.exports = __webpack_public_path__ + "img/1.d8b081d3.jpg";